module.exports = __webpack_public_path__ + "img/制御工学1_2.e6587405.png";